// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useState, useContext} from 'react';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import {Settings_context} from '../settings_ctx';
import {use_pathname} from '../lib/use_pathname';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import {uri} from '/util/escape.js';
import {perr} from 'hola_pub_util';
import util from '/util/util.js';
import {Spinner} from '../lib/spinner';
import {Button} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';

interface i_refund_btn_props {
    success_url: string;
    fail_url: string;
    cta: string;
    is_in_center: boolean;
    is_check_refund: boolean;
    policy?: string;
}

export const Refund_btn = (props: i_refund_btn_props)=>{
    const {success_url, fail_url, policy, cta, is_in_center = false,
        is_check_refund = true
    } = props;
    const {pathname} = use_pathname();
    const get_step_url = (step_value: string)=>{
        const decoded_step = decodeURIComponent(step_value);
        const step_index = pathname.indexOf('/step/');
        if (step_index === -1)
            return `${pathname}/${decoded_step}`;
        const base = pathname.substring(0, step_index);
        return `${base}/step/${decoded_step}`;
    };
    // @ts-ignore
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const [is_loading, set_is_loading] = useState(false);
    const check_if_eligible = ()=>etask(function*(){
        set_is_loading(true);
        const url = uri('/check_refund_eligible',
            {policy: policy||'bought_wrong'});
        const elig = yield fetch(url, {method: 'POST'});
        set_is_loading(false);
        const is_eligible_for_refund = elig?.result;
        if (!is_eligible_for_refund)
        {
            perr({id: `www_payment_help_not_eligible`, info: {
                email: util.get(user, 'emails.0.value', ''),
                policy,
            }});
        }
        const next_url = is_eligible_for_refund ? success_url : fail_url;
        window.location.href = get_step_url(next_url);
    });
    const request_refund = ()=>{
        set_is_loading(true);
        etask(function*(){
          const body = {
            email: util.get(user, 'emails.0.value', ''),
            issue: ['eligible_refund_request'],
            details: [],
          };
          yield fetch('/refund'+location.search, {method: 'POST', body});
          set_is_loading(false);
          window.location.href = get_step_url(success_url);
        });
    };
    return <div className={cn({[theme.content_center]: is_in_center})}>
      {is_loading ? <Spinner/> :
        <Button caption={cta} on_click={is_check_refund ?
          check_if_eligible : request_refund}/>}
    </div>;
};

interface i_refund_btn_editor_props {
    value: i_refund_btn_props;
    on_change: (new_value: i_refund_btn_props)=>void;
}

export const Refund_btn_editor = (props: i_refund_btn_editor_props)=>{
    const {value, on_change} = props;
    const check_refund_editors = [
        {key: 'is_check_refund', label: 'Only check refund' +
            ' (now set to CHECK)', type: 'boolean'},
        {key: 'is_in_center', label: 'Display in center', type: 'boolean'},
        {key: 'success_url', label: 'URL on eligible', type: 'text'},
        {key: 'fail_url', label: 'URL on non-eligible', type: 'text'},
        {key: 'policy', label: 'Refund policy reason' +
          ' (optional, default: "bought_wrong")', type: 'text'},
        {key: 'cta', label: 'Button title', type: 'text'},
    ] as any;
    const request_refund_editors = [
        {key: 'is_check_refund', label: 'Only check refund' +
            ' (now set to SUBMIT)', type: 'boolean'},
        {key: 'is_in_center', label: 'Display in center', type: 'boolean'},
        {key: 'success_url', label: 'URL after submit', type: 'text'},
        {key: 'cta', label: 'Button title', type: 'text'},
    ];
    const editors = value.is_check_refund ?
        check_refund_editors : request_refund_editors;
    return <Editor value={value} on_change={on_change}
      editors={editors}/>;
};
